import { useImageStore } from '../store/ImageStore'
import { useShallow } from 'zustand/shallow'

export const useSelectedImages = () => {
  const [selected] = useImageStore(useShallow((state) => [state.selected]))

  return { images: selected, count: selected?.length || 0 }
}
